<template>
  <router-link
    :to="{
      name: 'LeadersDraft',
      params: { draft_id: entity.id },
      query: { tab: 'search', id: draw.rider.user_id, select: 'competitor' }
    }"
  >
    {{ draw.rider.name }}
  </router-link>
</template>

<script>
export default {
  inject: ['entity'],
  props: {
    draw: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
  a {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/Links/LinkRider.vue